/* v5 — extended engagement window 20s → 30s (Rafał+Nikol 2026-05-15). */
(function () {
  'use strict';
  var ctx = window.__BEJESA_TRACK__ || {};

  function fire(name, params) {
    params = params || {};
    if (typeof window.gtag === 'function') { gtag('event', name, params); return 'gtag'; }
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      var p = { event: name }; for (var k in params) p[k] = params[k];
      window.dataLayer.push(p); return 'dataLayer';
    }
    return null;
  }

  function describe(el) {
    if (!el) return '(null)';
    var cls = String(el.className || '').split(' ').filter(Boolean).slice(0, 3).join('.');
    return el.tagName + (cls ? '.' + cls : '');
  }

  function textOf(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isMaterialMatch(text) {
    if (!text || text.length === 0 || text.length > 60) return false;
    if (text.indexOf('wymiary i materia') === -1) return false;
    if (text.indexOf('opis') !== -1) return false;
    if (text.indexOf('dostawy') !== -1) return false;
    if (text.indexOf('instrukcja') !== -1) return false;
    return true;
  }

  function isMaterialTab(el) {
    // Strategy 1: walk up DOM, check at each level
    var cur = el, depth = 0;
    while (cur && cur !== document.body && depth < 8) {
      if (isMaterialMatch(textOf(cur))) return { hit: cur, via: 'walk-up depth=' + depth };
      cur = cur.parentElement; depth++;
    }
    // Strategy 2: closest() to GemPages accordion item, look at header child
    var item = el.closest('[class*="accordion-item"], [class*="gp-collapsible"], [class*="accordion__item"]');
    if (item) {
      // Try header / trigger / title within the item
      var header = item.querySelector('[class*="trigger"], [class*="header"], [class*="title"], button, summary, h1, h2, h3, h4, h5');
      if (header && isMaterialMatch(textOf(header))) return { hit: header, via: 'closest accordion-item header' };
    }
    return null;
  }

  var clickTime = 0, fired = false;

  document.addEventListener('click', function (e) {
    var match = isMaterialTab(e.target);
    if (!match) {
      // Quiet now — only log on matches
      return;
    }
    console.log('[bejesa-track] MATCH via', match.via, '-> element:', describe(match.hit), 'text:', JSON.stringify(textOf(match.hit)));

    var via = fire('material_tab_click', {
      product_handle: ctx.handle, product_title: ctx.title, product_id: ctx.id
    });
    console.log('[bejesa-track] material_tab_click fired via', via, '— product:', ctx.handle);

    clickTime = Date.now(); fired = false;
    setTimeout(function () {
      if (clickTime > 0 && !fired) {
        fire('material_engagement_30s', { product_handle: ctx.handle, bounced: false, seconds_after_click: 30 });
        fired = true;
        console.log('[bejesa-track] engagement_30s STAYED');
      }
    }, 30000);
  }, true);

  function reportIfBounced() {
    if (clickTime === 0 || fired) return;
    var elapsed = (Date.now() - clickTime) / 1000;
    if (elapsed > 30) return;
    fire('material_engagement_30s', { product_handle: ctx.handle, bounced: true, seconds_after_click: Math.round(elapsed * 10) / 10 });
    fired = true;
    console.log('[bejesa-track] engagement_30s BOUNCED at', elapsed, 's');
  }
  window.addEventListener('pagehide', reportIfBounced);
  window.addEventListener('beforeunload', reportIfBounced);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') reportIfBounced();
  });

  console.log('[bejesa-track v5] active (30s window). gtag:', typeof window.gtag, 'dataLayer:', !!window.dataLayer);
})();
